import { Form, Radio as AntdRadio } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Card } from "ui/Card"
import { Radio } from "ui/Radio"

export const DURATION_TYPES = {
  SINGLE_DAY: "single_day",
  MULTI_DAY: "multi_day",
}

export const ExperienceDurationType = ({ disabled }) => {
  const { t } = useTranslation()

  return (
    <Card title={t("listings.tabs.scheduling.sections.duration_type.title")} className="mb-3xl">
      <Form.Item name="duration_type" initialValue={DURATION_TYPES.SINGLE_DAY} rules={[{ required: true }]}>
        <AntdRadio.Group disabled={disabled}>
          <Radio value={DURATION_TYPES.SINGLE_DAY}>
            {t("listings.tabs.scheduling.sections.duration_type.single_day")}
          </Radio>
          <Radio value={DURATION_TYPES.MULTI_DAY}>
            {t("listings.tabs.scheduling.sections.duration_type.multi_day")}
          </Radio>
        </AntdRadio.Group>
      </Form.Item>
    </Card>
  )
}

ExperienceDurationType.propTypes = {
  disabled: PropTypes.bool,
}
